import {
    useCategoryPostsLazyQuery,
    useHomepagePostsLazyQuery,
    useProductPostsQuery,
} from './gql/useful-information.graphql';

export function useHomepagePosts() {
    const [fetchHomepagePostsQuery, {data, loading, error}] = useHomepagePostsLazyQuery({
        notifyOnNetworkStatusChange: true,
    });

    return {
        fetchData: fetchHomepagePostsQuery,
        usefulInformation: data?.homepagePosts?.items ?? [],
        isLoading: loading,
        error,
    };
}

export function useCategoryPosts() {
    const [fetchCategoryPostsQuery, {data, loading, error}] = useCategoryPostsLazyQuery({
        notifyOnNetworkStatusChange: true,
    });

    const fetchData = (categoryId: number) => {
        return fetchCategoryPostsQuery({
            variables: {
                categoryId,
            },
        });
    };

    return {
        fetchData,
        usefulInformation: data?.categoryPosts?.items ?? [],
        isLoading: loading,
        error,
    };
}

export function useProductPosts(productId: number) {
    const {data, loading, error} = useProductPostsQuery({
        variables: {
            productId,
        },
    });

    return {
        usefulInformation: data?.productPosts?.items ?? [],
        isLoading: loading,
        error,
    };
}
